import React from 'react';
import PropTypes from 'prop-types';

import RatioContainer from 'components/consumer/RatioContainer';
import Placeholder from 'components/consumer/Placeholder';
import usePDPPhotos from 'data-hooks/usePDPPhotos';
import usePDPBasicDetails from 'components/consumer/PDP/state/context/usePDPBasicDetails';
import useModularPDPPhotos from 'data-hooks/useModularPDPPhotos';
import usePDPViewGalleryImageEvent from 'data-hooks/useEvents/usePDPViewGalleryImageEvent';
import SuspenseWithLoader from 'components/consumer/SuspenseWithLoader';
import ReRenderOnMount from 'components/consumer/ReRenderOnMount';
import PDPMobileStudioPhotoGalleryUI from './PDPMobileStudioPhotoGalleryUI';

const PDPMobileStudioPhotoGalleryInner = ({
  pdpIsModularBYOProduct = false,
  linkTo,
  mode = 'pdp',
  slug,
}) => {
  const {
    loading: photosLoading,
    error: photosError,
    data: photosData,
  } = usePDPPhotos(null, slug);

  const {
    loading: basicDetailsLoading,
    error: basicDetailsError,
    data: basicDetailsData,
  } = usePDPBasicDetails();

  const { viewGalleryImageEvent } = usePDPViewGalleryImageEvent();

  let modularPhotosData = useModularPDPPhotos(null, slug);

  if (!pdpIsModularBYOProduct) {
    modularPhotosData = null;
  }

  if (
    photosLoading ||
    basicDetailsLoading ||
    (pdpIsModularBYOProduct && modularPhotosData.loading)
  ) {
    return (
      <RatioContainer>
        <Placeholder type="rect" loading />
      </RatioContainer>
    );
  }

  if (photosError || basicDetailsError) {
    return null;
  }

  const { studioPhotos, enableCrops, introVideoIds } = pdpIsModularBYOProduct
    ? modularPhotosData.data
    : photosData;

  const { name } = basicDetailsData;

  return (
    <PDPMobileStudioPhotoGalleryUI
      campaign={basicDetailsData?.custom_properties?.campaign}
      enableCrops={enableCrops}
      introVideoId={introVideoIds?.desktop}
      linkTo={linkTo}
      mode={mode}
      photos={studioPhotos}
      productName={name}
      viewGalleryImageEvent={viewGalleryImageEvent}
    />
  );
};

PDPMobileStudioPhotoGalleryInner.propTypes = {
  pdpIsModularBYOProduct: PropTypes.bool,
  linkTo: PropTypes.string,
  mode: PropTypes.oneOf(['pdp', 'quickview']),
  slug: PropTypes.string,
};

const PDPMobileStudioPhotoGallery = props => (
  <ReRenderOnMount>
    <SuspenseWithLoader
      fallback={
        <RatioContainer>
          <Placeholder type="rect" loading />
        </RatioContainer>
      }
    >
      <PDPMobileStudioPhotoGalleryInner {...props} />
    </SuspenseWithLoader>
  </ReRenderOnMount>
);

export default PDPMobileStudioPhotoGallery;
